/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AdminsTable.vue?vue&type=template&id=1b3abf20&scoped=true"
import script from "./AdminsTable.vue?vue&type=script&lang=js"
export * from "./AdminsTable.vue?vue&type=script&lang=js"
import style0 from "./AdminsTable.vue?vue&type=style&index=0&id=1b3abf20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3abf20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3abf20')) {
      api.createRecord('1b3abf20', component.options)
    } else {
      api.reload('1b3abf20', component.options)
    }
    module.hot.accept("./AdminsTable.vue?vue&type=template&id=1b3abf20&scoped=true", function () {
      api.rerender('1b3abf20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/AdminsTable.vue"
export default component.exports